import React, { ReactElement, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import dayjs from 'dayjs';

import { getCustomerCacheMap } from 'src/util/resources/CustomerCache';
import { ISalesorder } from 'src/types';
import { Spinner } from 'src/components/Spinner';

export interface ISalesorderTableProps {
  salesordersList: ISalesorder[];
}

export const SalesorderTable = ({ salesordersList }: ISalesorderTableProps): ReactElement => {

  const  {isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();

  const [customerMap, setCustomerMap] = useState<Map<number, string>>(new Map());

  getAccessTokenSilently().then(accessToken =>  {
    getCustomerCacheMap(accessToken || '').then(custMap => setCustomerMap(custMap))
  })

  if(isLoading) {
    return <Spinner />
  }
  return <table className="uk-table uk-table-divider uk-table-small uk-margin-right-small">
    <thead>
      <tr>
        <th>Sales Order</th>
        <th>Name</th>
        <th>Type</th>
        <th>Customer</th>
        <th>Issue</th>
        <th>Ship Date</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {salesordersList.map(s => <tr key={s.salesorderId}>
        <td>{s.salesorderRef}</td>
        <td>{s.name}</td>
        <td>{s.salesorderType}</td>
        <td>{customerMap.get(s.customerId)}</td>
        <td><a href={`https://team-sesame.atlassian.net/browse/${s.issue}`}>{s.issue}</a></td>
        <td>{s.shipDate}</td>
        <td className="uk-text-right">{s.shipDate ? dayjs(s.shipDate).format("DD/MM/YYYY") :
          <a data-uk-icon="pencil" href={`/editSalesOrder?salesorder=${s.salesorderId}`}></a>}</td>
      </tr>)}
    </tbody>
  </table>
}
